import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AccountShell } from "@/components/account";
import { useSeo } from "@/lib/seo";

export default function VerifyEmail() {
  useSeo({ title: "Verify your email", path: "/verify-email", noindex: true });
  const { refresh } = useAuth();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("checking");
  const [role, setRole] = useState("client");

  useEffect(() => {
    if (!token) { setStatus("invalid"); return; }
    api.verifyEmail(token)
      .then(async (r) => { setRole(r.role || "client"); setStatus("ok"); try { await refresh(); } catch (e) {} })
      .catch(() => setStatus("invalid"));
  }, [token, refresh]);

  const dash = role === "tester" ? "/tester" : "/dashboard";

  return (
    <AccountShell title="Verify your email">
      {status === "checking" && <p className="auth-sub" data-testid="verify-checking">Verifying your email…</p>}
      {status === "ok" && (
        <div data-testid="verify-ok">
          <p className="auth-sub">Your email is verified. Thank you!</p>
          <Link className="btn blue auth-submit" to={dash} data-testid="verify-continue">Go to your dashboard</Link>
        </div>
      )}
      {status === "invalid" && (
        <div data-testid="verify-invalid">
          <p className="auth-sub">This verification link is invalid or has expired. Sign in and request a fresh link from your dashboard.</p>
          <Link className="btn blue auth-submit" to="/login" data-testid="verify-to-login">Sign in</Link>
        </div>
      )}
    </AccountShell>
  );
}
